const __WEBPACK_NAMESPACE_OBJECT__ = flarum.core.compat['v17development/blog/components/FeaturedBlogItem'];